import axios from 'axios'

export default {
  ListCombo () {
    return new Promise((resolve, reject) => {
      // Recupera del cache la list de items
      const storage = sessionStorage.getItem('provincias_itemscombo')

      // Si ya estan los datos en el storage, se retorna de ahi, solo para las paramtétricas
      if (storage !== null && storage !== '' && storage !== undefined)
        resolve(JSON.parse(storage))
      else {
        // realizo el llamado ajax
        const p = axios.get('/api/provincias/ListCombo')

        p.then(({ data }) => {
          sessionStorage.setItem('provincias_itemscombo', JSON.stringify(data.recordset))
          resolve(data.recordset)
        }).catch((err) => {
          reject(err)
        })
      }
    })
  },
  List (params) {
    return axios.get('/api/provincias/List', { params })
  },
  Agregar (params) {
    return axios.post('/api/provincias', params)
  },
  Modificar (params) {
    return axios.put('/api/provincias', params)
  },
  Borrar (params) {
    return axios.delete('/api/provincias', { params })
  }
}
